"use client";

import { useCallback, useState } from "react";
import { saveOptimizerMobileView } from "@/lib/actions/optimizer-sticky-filters";
import type { MobileView } from "@/lib/saved-filter-pages";

let chosen: MobileView | null = null;

export function useMobileViewPreference(initialView: MobileView) {
  const [view, setViewState] = useState<MobileView>(() => chosen ?? initialView);
  const setView = useCallback((next: MobileView) => {
    chosen = next;
    setViewState(next);
    saveOptimizerMobileView(next).catch(() => {});
  }, []);
  return { view, setView };
}
